// Mock data layer for Sunlight Grounds Care Client Portal
// This file simulates backend responses for development and testing

export const mockData = {
  // Login response
  loginResponse: {
    token: "mock-jwt-token-sunlight-grounds-care",
    user: {
      id: "uuid-001",
      name: "Robert",
      role: "client",
      hotel_id: null,
      allowed_tabs: ["landscape_overview", "landscape_schedule", "landscape_photos", "communication"]
    }
  },

  // Properties
  properties: [
    {
      id: "prop-001",
      name: "Martinez Home",
      address: "3721 Huntington Dr, Pasadena, CA 91107",
      type: "residential",
      status: "active",
      created_at: "2024-01-15T00:00:00Z"
    },
    {
      id: "prop-002",
      name: "Martinez Guest House",
      address: "1450 Oak Knoll Ave, Pasadena, CA 91106",
      type: "residential",
      status: "active",
      created_at: "2024-06-10T00:00:00Z"
    },
    {
      id: "prop-003",
      name: "Martinez Rental",
      address: "820 S Lake Ave, Pasadena, CA 91101",
      type: "residential",
      status: "active",
      created_at: "2025-02-01T00:00:00Z"
    }
  ],

  // Dashboard data
  dashboardData: {
    next_visit: "2026-03-25",
    services_ytd: 18,
    services_last_year: 14,
    open_requests: 2,
    balance: 0,
    shared_photo_dates: ["2026-02-18", "2026-02-24"],
    photo_summary: {
      total_photos: 12,
      rooms_with_photos: 4,
      days_with_photos: 2
    },
    service_requests_summary: {
      pending: 2,
      in_progress: 0,
      completed: 16
    }
  },

  // Landscape overview
  landscapeOverview: {
    property_name: "Martinez Home",
    city: "Pasadena",
    subscription: "Premium",
    status: "active"
  },

  // Schedule
  schedule: {
    upcoming: {
      date: "2026-03-25",
      time: "8:00 AM",
      service: "Lawn Maintenance",
      staff_name: "Carlos M.",
      status: "confirmed",
      tasks: [
        { name: "Lawn mow & edge", duration: "45 min" },
        { name: "Shrub trimming", duration: "20 min" },
        { name: "Leaf blowing", duration: "15 min" },
        { name: "Clippings removal", duration: "10 min" }
      ]
    },
    last_service: {
      date: "2026-02-24",
      service: "Lawn Maintenance",
      crew: "Carlos M.",
      status: "completed"
    }
  },

  // Staff status (for polling)
  staffStatus: {
    status: "en route",
    arrival_time: "10:30 AM",
    staff_name: "Carlos M.",
    service: "Grounds Care",
    date: "Apr 3",
    eta_minutes: 15
  },

  // Property staff
  propertyStaff: {
    groundskeeper: "Carlos M.",
    manager: "Jiovani R.",
    plan: "Premium"
  },

  // Services
  services: [
    { name: "Maintenance", frequency: "Weekly", icon: "🌿" },
    { name: "Irrigation", frequency: "Monthly", icon: "💧" },
    { name: "Pressure Washing", frequency: "Quarterly", icon: "🚿" }
  ],

  // Recommendation
  recommendation: {
    title: "Strengthen your lawn this spring",
    description: "Fertilizer builds sod resistance to fungus and delivers vibrant green color year-round.",
    service: "Lawn Fertilization",
    price_low: 60,
    price_high: 120,
    icon: "🌱",
    bg_color: "#d4e8c4"
  },

  // Photos
  photos: {
    shared_dates: ["2026-03-03", "2026-03-10", "2026-03-17", "2026-03-25"],
    visits: [
      {
        date: "2026-03-17",
        service: "Lawn Maintenance",
        areas: [
          { 
            name: "Front yard", count: 2,
            thumbnail: "https://images.unsplash.com/photo-1589321084815-4e5f1740cbc6?w=400&h=300&fit=crop",
            photos: [
              { url: "https://images.unsplash.com/photo-1589321084815-4e5f1740cbc6?w=1200&fit=crop", label: "After mowing" },
              { url: "https://images.unsplash.com/photo-1703432043433-3bb86c844968?w=1200&fit=crop", label: "Before mowing" }
            ]
          },
          { 
            name: "Back yard", count: 2,
            thumbnail: "https://images.pexels.com/photos/238377/pexels-photo-238377.jpeg?auto=compress&w=400&h=300&fit=crop",
            photos: [
              { url: "https://images.pexels.com/photos/238377/pexels-photo-238377.jpeg?auto=compress&w=1200", label: "Patio area" },
              { url: "https://images.pexels.com/photos/3614085/pexels-photo-3614085.jpeg?auto=compress&w=1200", label: "Garden seating" }
            ]
          }
        ]
      },
      {
        date: "2026-03-10",
        service: "Pressure Washing",
        areas: [
          { 
            name: "Driveway", count: 3,
            thumbnail: "https://images.pexels.com/photos/209296/pexels-photo-209296.jpeg?auto=compress&w=400&h=300&fit=crop",
            photos: [
              { url: "https://images.pexels.com/photos/209296/pexels-photo-209296.jpeg?auto=compress&w=1200", label: "After washing" },
              { url: "https://images.unsplash.com/photo-1768941124460-6fa7161715ff?w=1200&fit=crop", label: "Front view" },
              { url: "https://images.pexels.com/photos/3555615/pexels-photo-3555615.jpeg?auto=compress&w=1200", label: "Curb view" }
            ]
          }
        ]
      },
      {
        date: "2026-03-03",
        service: "Lawn Maintenance",
        areas: [
          { 
            name: "Front yard", count: 2,
            thumbnail: "https://images.unsplash.com/photo-1661133732576-6140941d5421?w=400&h=300&fit=crop",
            photos: [
              { url: "https://images.unsplash.com/photo-1661133732576-6140941d5421?w=1200&fit=crop", label: "Freshly mowed" },
              { url: "https://images.unsplash.com/photo-1650905518179-2374cb4a3e8e?w=1200&fit=crop", label: "Edge detail" }
            ]
          },
          { 
            name: "Hedges", count: 2,
            thumbnail: "https://images.unsplash.com/photo-1659029312197-eff8009d8dd6?w=400&h=300&fit=crop",
            photos: [
              { url: "https://images.unsplash.com/photo-1659029312197-eff8009d8dd6?w=1200&fit=crop", label: "After trimming" },
              { url: "https://images.unsplash.com/photo-1706968487669-5ef11eedffdc?w=1200&fit=crop", label: "Fence line" }
            ]
          }
        ]
      }
    ]
  },

  // Service request types
  requestTypes: [
    { id: "tree_trimming", name: "Tree Trimming" },
    { id: "lawn_fertilization", name: "Lawn Fertilization" },
    { id: "irrigation_check", name: "Irrigation Check" },
    { id: "pressure_washing", name: "Pressure Washing" },
    { id: "gutter_cleaning", name: "Gutter Cleaning" },
    { id: "other", name: "Other" }
  ],

  // Locations
  locations: {
    rooms: [],
    zones: [
      { id: "zone-001", name: "Front yard" },
      { id: "zone-002", name: "Back yard" },
      { id: "zone-003", name: "Full property" },
      { id: "zone-004", name: "Driveway" }
    ]
  },

  // Messages / thread
  messages: [
    {
      id: "msg-001",
      from: "team",
      text: "Reminder — your visit is March 25 at 8:00 AM. Carlos will be your crew lead.",
      time: "Mar 19, 9:14 AM"
    },
    {
      id: "msg-002",
      from: "client",
      text: "Thanks! Can you check the back fence edge this visit?",
      time: "Mar 19, 10:02 AM"
    },
    {
      id: "msg-003",
      from: "team",
      text: "Noted on your profile — Carlos will handle it.",
      time: "Mar 19, 10:45 AM"
    }
  ],

  // Account / property info
  propertyInfo: {
    address: "3721 Huntington Dr, Pasadena, CA 91107",
    type: "Single family",
    lot_size: "~6,500 sq ft",
    gate_code: "#4821",
    member_since: "January 2024"
  },

  // Billing with Stripe integration - matches real Stripe invoice structure
  billing: {
    invoices: [
      { 
        id: "inv-032",
        stripe_invoice_id: "in_1abc123",
        service: "Pressure Washing", 
        description: "Quarterly pressure washing service",
        date: "Apr 1, 2026",
        due_date: "Apr 15, 2026",
        amount: 320, 
        status: "open",  // Stripe statuses: draft, open, paid, uncollectible, void
        hosted_invoice_url: "https://invoice.stripe.com/i/mock_inv_032",
        invoice_pdf: "https://invoice.stripe.com/i/mock_inv_032/pdf"
      },
      { 
        id: "inv-031",
        stripe_invoice_id: "in_2def456",
        service: "Lawn Maintenance", 
        description: "Bi-weekly lawn maintenance",
        date: "Mar 10, 2026",
        due_date: "Mar 24, 2026",
        amount: 185, 
        status: "paid",
        paid_at: "Mar 12, 2026",
        hosted_invoice_url: "https://invoice.stripe.com/i/mock_inv_031",
        invoice_pdf: "https://invoice.stripe.com/i/mock_inv_031/pdf"
      },
      { 
        id: "inv-028",
        stripe_invoice_id: "in_3ghi789",
        service: "Irrigation Repair", 
        description: "Sprinkler head replacement and zone repair",
        date: "Feb 5, 2026",
        due_date: "Feb 19, 2026",
        amount: 475, 
        status: "paid",
        paid_at: "Feb 8, 2026",
        hosted_invoice_url: "https://invoice.stripe.com/i/mock_inv_028",
        invoice_pdf: "https://invoice.stripe.com/i/mock_inv_028/pdf"
      }
    ],
    ytd_total: 980,
    payment_method: {
      brand: "Visa",
      last4: "4242",
      exp: "08/27"
    }
  },

  // Service requests
  serviceRequests: [
    {
      id: 'req-001',
      request_type: 'Tree Trimming',
      service_type: 'tree_trimming',
      location_text: 'Front yard',
      description: 'Large oak tree branches hanging over walkway, need trimmed back before spring.',
      status: 'pending',
      preferred_date: '2026-04-10',
      created_at: '2026-03-18T14:30:00Z',
    },
    {
      id: 'req-002',
      request_type: 'Irrigation Check',
      service_type: 'irrigation_check',
      location_text: 'Back yard',
      description: 'Zone 3 sprinkler heads seem clogged, uneven coverage on the east side.',
      status: 'in_progress',
      assigned_to: 'Carlos M.',
      preferred_date: '2026-03-25',
      created_at: '2026-03-10T09:15:00Z',
    },
    {
      id: 'req-003',
      request_type: 'Pressure Washing',
      service_type: 'pressure_washing',
      location_text: 'Driveway',
      description: 'Quarterly driveway and front walkway wash.',
      status: 'completed',
      assigned_to: 'Carlos M.',
      preferred_date: '2026-03-01',
      created_at: '2026-02-20T11:00:00Z',
      completed_at: '2026-03-02T16:00:00Z',
    },
    {
      id: 'req-004',
      request_type: 'Gutter Cleaning',
      service_type: 'gutter_cleaning',
      location_text: 'Full property',
      description: 'Seasonal gutter clean-out before rainy season.',
      status: 'completed',
      assigned_to: 'Jiovani R.',
      preferred_date: '2026-02-15',
      created_at: '2026-02-05T08:00:00Z',
      completed_at: '2026-02-16T14:30:00Z',
    },
  ],

  // Weather (mock — replace with OpenWeatherMap later)
  weather: {
    temp: 78,
    condition: "Clear skies",
    humidity: 51,
    wind: 12,
    icon: "☀️",
    forecast: [
      { day: "Mo", date: "Mar 31", icon: "⛅", temp: 72 },
      { day: "Tu", date: "Apr 1", icon: "🌤", temp: 75 },
      { day: "We", date: "Apr 2", icon: "☀️", temp: 80 },
      { day: "Th", date: "Apr 3", icon: "☀️", temp: 82 },
      { day: "Fr", date: "Apr 4", icon: "⛅", temp: 74 },
      { day: "Sa", date: "Apr 5", icon: "☀️", temp: 79 }
    ]
  }
};

// Mock API functions
export const mockApi = {
  login: async (email, password) => {
    await delay(500);
    if (email === "testclient@example.com" && password === "demo123") {
      return mockData.loginResponse;
    }
    // For mock mode, accept any credentials
    return mockData.loginResponse;
  },

  getProperties: async () => {
    await delay(300);
    return mockData.properties;
  },

  getDashboardData: async (propertyId, date) => {
    await delay(300);
    return mockData.dashboardData;
  },

  getLandscapeOverview: async () => {
    await delay(300);
    return mockData.landscapeOverview;
  },

  getLandscapeSchedule: async () => {
    await delay(300);
    return mockData.schedule;
  },

  getUpcomingVisits: async (propertyId) => {
    await delay(300);
    return mockData.schedule.upcoming;
  },

  getStaffStatus: async (propertyId) => {
    await delay(200);
    return mockData.staffStatus;
  },

  getPropertyStaff: async () => {
    await delay(300);
    return mockData.propertyStaff;
  },

  getServices: async () => {
    await delay(300);
    return mockData.services;
  },

  getRecommendations: async (propertyId) => {
    await delay(300);
    return mockData.recommendation;
  },

  getLandscapePhotos: async () => {
    await delay(300);
    return mockData.photos;
  },

  getServiceRequestTypes: async (propertyId) => {
    await delay(300);
    return mockData.requestTypes;
  },

  getLocations: async (propertyId) => {
    await delay(300);
    return mockData.locations;
  },

  getServiceRequests: async (propertyId) => {
    await delay(300);
    return mockData.serviceRequests;
  },

  createServiceRequest: async (data) => {
    await delay(400);
    return {
      id: `req-${Date.now()}`,
      ...data,
      status: "pending",
      created_at: new Date().toISOString()
    };
  },

  getPropertyInfo: async (propertyId) => {
    await delay(300);
    return mockData.propertyInfo;
  },

  getPropertyNotes: async () => {
    await delay(300);
    return { gate_code: mockData.propertyInfo.gate_code };
  },

  getBilling: async () => {
    await delay(300);
    return mockData.billing;
  },

  getInvoices: async () => {
    await delay(300);
    return mockData.billing;
  },

  // Stripe: Create checkout session for paying an invoice
  createCheckoutSession: async (invoiceId) => {
    await delay(500);
    // In mock mode, we simulate the checkout URL
    // In production, this returns a real Stripe checkout URL
    return {
      checkout_url: `https://checkout.stripe.com/mock-session/${invoiceId}`
    };
  },

  // Stripe: Create setup intent for adding a payment method
  createSetupIntent: async () => {
    await delay(500);
    return {
      client_secret: "seti_mock_client_secret_123"
    };
  },

  // Stripe: Get billing portal URL
  getBillingPortal: async () => {
    await delay(500);
    return {
      portal_url: "https://billing.stripe.com/mock-portal"
    };
  },

  getWeather: async () => {
    await delay(200);
    return mockData.weather;
  },

  getMessages: async () => {
    await delay(300);
    return mockData.messages;
  },

  sendMessage: async (text) => {
    await delay(300);
    return {
      id: `msg-${Date.now()}`,
      from: "client",
      text,
      time: new Date().toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true })
    };
  }
};

// Helper function for simulating network delay
function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
